import React from 'react';
import PropTypes from 'prop-types';
import Image from './Image';
import Icon from '../Global/Icons/Icon';

const DiagramImage = ({ image, loggedInUserId, authorId }) => {
  const { content_id } = image;

  return (
    <div className="diagram-image">
      {loggedInUserId && authorId &&
        loggedInUserId === authorId &&
          <a className="edit-diagram-image-link btn btn--s btn--icon box-shadow-l" href={`/locker/my-content/diagram/${content_id}`}>
            <span className="visuallyhidden">Edit diagram</span>
            <Icon name="edit" />
          </a>
      }
      <Image image={image} />
    </div>
  );
};

DiagramImage.propTypes = {
  image: PropTypes.object.isRequired,
  loggedInUserId: PropTypes.number.isRequired,
  authorId: PropTypes.number.isRequired,
};

export default DiagramImage;



// WEBPACK FOOTER //
// ./library/app/components/Content/DiagramImage.js